import api from './api';
import authService from './auth.service.js';

const DashService = {
    DashView(classData) {
      return api.get('/dash', classData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch(async (error) => {
        if (error.response?.status === 401) {
          await authService.refreshToken();
          return api.get('/dash', classData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
        }
        throw error;
      });
    },
};

export default DashService;